/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdDomainSettingsAdvertisementFbInstantOptionsInterstitial } from './FxIdDomainSettingsAdvertisementFbInstantOptionsInterstitial';
import {
    FxIdDomainSettingsAdvertisementFbInstantOptionsInterstitialFromJSON,
    FxIdDomainSettingsAdvertisementFbInstantOptionsInterstitialFromJSONTyped,
    FxIdDomainSettingsAdvertisementFbInstantOptionsInterstitialToJSON,
    FxIdDomainSettingsAdvertisementFbInstantOptionsInterstitialToJSONTyped,
} from './FxIdDomainSettingsAdvertisementFbInstantOptionsInterstitial';
import type { FxIdDomainSettingsAdvertisementFbInstantOptionsRewarded } from './FxIdDomainSettingsAdvertisementFbInstantOptionsRewarded';
import {
    FxIdDomainSettingsAdvertisementFbInstantOptionsRewardedFromJSON,
    FxIdDomainSettingsAdvertisementFbInstantOptionsRewardedFromJSONTyped,
    FxIdDomainSettingsAdvertisementFbInstantOptionsRewardedToJSON,
    FxIdDomainSettingsAdvertisementFbInstantOptionsRewardedToJSONTyped,
} from './FxIdDomainSettingsAdvertisementFbInstantOptionsRewarded';

/**
 * 
 * @export
 * @interface FxIdDomainSettingsAdvertisementFbInstantOptions
 */
export interface FxIdDomainSettingsAdvertisementFbInstantOptions {
    /**
     * 
     * @type {FxIdDomainSettingsAdvertisementFbInstantOptionsRewarded}
     * @memberof FxIdDomainSettingsAdvertisementFbInstantOptions
     */
    Rewarded?: FxIdDomainSettingsAdvertisementFbInstantOptionsRewarded | null;
    /**
     * 
     * @type {FxIdDomainSettingsAdvertisementFbInstantOptionsInterstitial}
     * @memberof FxIdDomainSettingsAdvertisementFbInstantOptions
     */
    Interstitial?: FxIdDomainSettingsAdvertisementFbInstantOptionsInterstitial | null;
}

/**
 * Check if a given object implements the FxIdDomainSettingsAdvertisementFbInstantOptions interface.
 */
export function instanceOfFxIdDomainSettingsAdvertisementFbInstantOptions(value: object): value is FxIdDomainSettingsAdvertisementFbInstantOptions {
    return true;
}

export function FxIdDomainSettingsAdvertisementFbInstantOptionsFromJSON(json: any): FxIdDomainSettingsAdvertisementFbInstantOptions {
    return FxIdDomainSettingsAdvertisementFbInstantOptionsFromJSONTyped(json, false);
}

export function FxIdDomainSettingsAdvertisementFbInstantOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsAdvertisementFbInstantOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'Rewarded': json['Rewarded'] == null ? undefined : FxIdDomainSettingsAdvertisementFbInstantOptionsRewardedFromJSON(json['Rewarded']),
        'Interstitial': json['Interstitial'] == null ? undefined : FxIdDomainSettingsAdvertisementFbInstantOptionsInterstitialFromJSON(json['Interstitial']),
    };
}

export function FxIdDomainSettingsAdvertisementFbInstantOptionsToJSON(json: any): FxIdDomainSettingsAdvertisementFbInstantOptions {
    return FxIdDomainSettingsAdvertisementFbInstantOptionsToJSONTyped(json, false);
}

export function FxIdDomainSettingsAdvertisementFbInstantOptionsToJSONTyped(value?: FxIdDomainSettingsAdvertisementFbInstantOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Rewarded': FxIdDomainSettingsAdvertisementFbInstantOptionsRewardedToJSON(value['Rewarded']),
        'Interstitial': FxIdDomainSettingsAdvertisementFbInstantOptionsInterstitialToJSON(value['Interstitial']),
    };
}

